import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_storage_organization: FaireCategoryEntity = {
  token: "catalog_cat_storage-organization",
  type: "category",
  name: "Storage & organization",
  count: 84,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
